const state = {
  content: null
}

const getters = {
  token: state => state.content
}

const actions = {
  setToken({
    state,
    commit
  }, data) {
    commit('setToken', data)
  },

}

const mutations = {
  setToken(state, content) {
    state.content = content
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/token.js